export const getJobDomain = (jobUrl = "") => {
  const value = String(jobUrl).trim();
  if (!value) return "";

  try {
    const url = new URL(
      /^https?:\/\//i.test(value) ? value : `https://${value}`,
    );
    return url.hostname.replace(/^www\./i, "").toLowerCase();
  } catch {
    return "";
  }
};

export const getJobFaviconUrl = (jobUrl) => {
  const domain = getJobDomain(jobUrl);
  return domain
    ? `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=128`
    : "/assets/image/unknown.png";
};
